import { createContext, useContext, useEffect, useState } from "react";
import { trackEvent } from "@/lib/api";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("fk_cart")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("fk_cart", JSON.stringify(items));
  }, [items]);

  const addToCart = (product, qty = 1) => {
    trackEvent("add_to_cart", { product_id: product.id });
    setItems((prev) => {
      const found = prev.find((i) => i.id === product.id);
      if (found) {
        return prev.map((i) =>
          i.id === product.id ? { ...i, qty: i.qty + qty } : i
        );
      }
      return [
        ...prev,
        {
          id: product.id,
          name: product.name,
          price: product.price,
          mrp: product.mrp,
          image_url: product.image_url,
          qty,
        },
      ];
    });
  };

  const updateQty = (id, qty) => {
    if (qty < 1) return;
    const item = items.find((i) => i.id === id);
    if (item && qty !== item.qty)
      trackEvent(qty > item.qty ? "add_to_cart" : "remove_from_cart", { product_id: id });
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty } : i)));
  };

  const removeItem = (id, track = true) => {
    const item = items.find((i) => i.id === id);
    if (track && item) for (let n = 0; n < item.qty; n++) trackEvent("remove_from_cart", { product_id: id });
    setItems((prev) => prev.filter((i) => i.id !== id));
  };

  const clearCart = () => setItems([]);

  const totalMrp = items.reduce((s, i) => s + i.mrp * i.qty, 0);
  const totalPrice = items.reduce((s, i) => s + i.price * i.qty, 0);
  const totalQty = items.reduce((s, i) => s + i.qty, 0);
  const discount = totalMrp - totalPrice;
  const delivery = 0;
  const payable = totalPrice + delivery;

  return (
    <CartContext.Provider
      value={{
        items,
        addToCart,
        updateQty,
        removeItem,
        clearCart,
        totalMrp,
        totalPrice,
        totalQty,
        discount,
        delivery,
        payable,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
